import * as Highcharts from 'Highcharts';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {CommonService} from 'src/app/services/common.service';
import {MapboxGlService} from 'src/app/services/mapbox-gl.service';

@Component({
    selector: 'app-mapboxgl-graph',
    templateUrl: './mapboxgl-graph.component.html',
    styleUrls: ['./mapboxgl-graph.component.scss']
})
export class MapboxglGraphComponent implements OnInit {

    public graphData: any;
    public service: MapboxGlService;

    constructor(
        public commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<MapboxglGraphComponent>
    ) {
        this.service = this.data.service;
    }

    async ngOnInit(): Promise<void> {
        const res: any = await this.commonService.getDataGraph();
        if (res) {
            this.graphData = res.data;
            this.proportionOfSubBasinArea();
            this.runoffGenerated();
            this.subBasinByDrainCapacityAtPercent();
            this.totalRunoff();
        }
    }

    proportionOfSubBasinArea(): void {
        Highcharts.chart('proportionOfSubBasinArea', {
            chart: {
                style: {
                    fontFamily: 'Roboto'
                },
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                layout: 'vertical',
                x: 0,
                y: 50,
                itemMarginTop: 10,
            },
            title: {
                text: 'Proportion of Sub-basins Area',
                align: 'left'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: 'Percent',
                colorByPoint: true,
                data: this.graphData.proportionOfSubBasinAreaResult
            }]
        } as any);
    }

    runoffGenerated(): void {
        Highcharts.chart('runoffGenerated', {
            chart: {
                style: {
                    fontFamily: 'Roboto'
                },
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                layout: 'vertical',
                x: 0,
                y: 50,
                itemMarginTop: 10,
            },
            title: {
                text: 'Runoff generated',
                align: 'left'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: 'Percent',
                colorByPoint: true,
                data: this.graphData.runoffGeneratedResult
            }]
        } as any);
    }

    subBasinByDrainCapacityAtPercent(): void {
        Highcharts.chart('subBasinByDrainCapacityAtPercent', {
            chart: {
                style: {
                    fontFamily: 'Roboto'
                },
                type: 'column',
                inverted: true
            },
            xAxis: {
                startOnTick: true,
                categories: this.graphData.subBasinByDrainCapacityAtPercentResult.categories,
                gridLineWidth: 1,
            },
            title: {
                text: 'Sub basin by Drain Capacity at 100% and 80%',
                align: 'left'
            },
            plotOptions: {
                series: {
                    inside: false,
                    centerInCategory: true,
                    dataLabels: {
                        enabled: true,
                        y: 5000,
                        allowOverlap: true,
                        format: '{point.name}',
                    },
                }
            },
            series: this.graphData.subBasinByDrainCapacityAtPercentResult.series
        } as any);
    }

    totalRunoff(): void {
        Highcharts.chart('totalRunoff', {
            chart: {
                style: {
                    fontFamily: 'Roboto'
                },
                type: 'column',
                inverted: true
            },
            xAxis: {
                startOnTick: true,
                categories: this.graphData.totalRunoffResult.categories,
                gridLineWidth: 1,
            },
            title: {
                text: 'Watershed total runoff',
                align: 'left'
            },
            plotOptions: {
                series: {
                    inside: false,
                    centerInCategory: true,
                    dataLabels: {
                        enabled: true,
                        y: 5000,
                        allowOverlap: true,
                        format: '{point.name}',
                    }
                }
            },
            series: this.graphData.totalRunoffResult.series
        } as any);
    }

    close(): void {
        this.dialogRef.close();
    }

}
